/* eslint-disable @typescript-eslint/consistent-type-definitions */
// eventBus.ts
import mitt from "mitt";

export type Events = {
  "mollie-t2p-result": any;
  "softpos-status": {
    paymentId: string;
    orderId: string;
    cardholderTicket?: string;
    status?: "PAID" | "CANCEL" | "CHANGE";
  };
};

export const eventBus = mitt<Events>();
